import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Button, Icon, Carousel } from "antd";
import { TouchContainer } from "@/container";
import * as utils from "@/utils";
import "./style.less";

class View extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      autoplay: false,
      interval: 5000,
      _select: 0,
      full: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    const { autoplay = false } = this.props;
    if (autoplay) {
      this.setState({ autoplay });
      this.openAutoChange();
    }
  }

  componentWillReceiveProps({ autoplay, interval }) {
    if (autoplay !== this.state.autoplay) {
      this.setState({ autoplay });
      if (autoplay) {
        if (interval && interval !== this.state.interval)
          this.setState({ interval });
        this.openAutoChange();
      }
    }
  }
  openAutoChange() {
    if (this.timer) return;
    const { interval } = this.props;
    this.timer = setInterval(() => {
      const { autoplay, full } = this.state;
      if (full) return;
      if (!autoplay) {
        clearInterval(this.timer);
        this.timer = null;
        return;
      }
      this.next();
    }, interval || this.state.interval);
  }
  onChange = (index) => {
    this.setState({ _select: index });
    this.refs.previewMainCarousel && this.refs.previewMainCarousel.goTo(index);
  };
  onChangeFull = () => this.setState({ full: !this.state.full });
  renderThumb({ style, ...props }) {
    const thumbStyle = {
      backgroundColor: `rgba(255,255,255,.8)`,
      borderRadius: "5px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }
  next = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.preventDefault) e.preventDefault();

    const { childs = [], select, onChange } = this.props;
    const onIndex = select !== undefined || this.state._select;
    const total = childs.length - 1;
    (onChange || this.onChange)(onIndex + 1 > total ? 0 : onIndex + 1);
  };
  prev = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.preventDefault) e.preventDefault();
    const { childs = [], select, onChange } = this.props;
    const onIndex = select !== undefined || this.state._select;
    const total = childs.length - 1;
    (onChange || this.onChange)(onIndex - 1 < 0 ? total : onIndex - 1);
  };

  render() {
    const { full } = this.state;
    const { childs = [], select, onChange, mainClass, listClass } = this.props;
    const onIndex = select !== undefined || this.state._select;
    const Select = childs[onIndex];

    if (!Select) {
      return <div></div>;
    }
    return (
      <div className="com-shop-preview full--col flex col">
        {/* 展示 */}
        <section
          className={`com-shop-preview__main ${
            full ? "-full hover-container" : ""
          } flex center ${mainClass}`}
        >
          <div className="com-shop-preview__main-mask"></div>
          {full && (
            <div
              className="ab-col-center full flex space zindex-1 padding-lr"
              style={{ left: "0" }}
            >
              <Button
                className="hover-container__item"
                onClick={this.prev}
                size="large"
                shape="circle"
                icon="left"
              />
              <Button
                className="hover-container__item"
                onClick={this.next}
                size="large"
                shape="circle"
                icon="right"
              />
            </div>
          )}
          <TouchContainer
            className="absolute fill"
            style={{ left: "0", top: "0" }}
            left={this.next}
            right={this.prev}
            onClick={this.onChangeFull}
          >
            <Carousel ref="previewMainCarousel" dots={false} effect="fade">
              {childs.map((Item) => (
                <div className="fill">
                  <Item.view
                    {...{
                      ...(Select.props || {}),
                      fill: full,
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </TouchContainer>
          {full && (
            <p
              className="com-shop-preview__num absolute full txt-center txt-shadow theme-height font-size-14"
              style={{ left: "0" }}
            >
              {onIndex + 1} / {childs.length}
            </p>
          )}
          <Icon
            className="com-shop-preview__main-fullBtn"
            type={full ? "fullscreen-exit" : "fullscreen"}
            onClick={this.onChangeFull}
          />
        </section>
        {/* 预览列表 */}
        <section className={`com-shop-preview__pic-list shrink-0 ${listClass}`}>
          <Scrollbars
            className={utils.isWindows() ? "hall-scroll" : ""}
            autoHide
            renderThumbVertical={this.renderThumb}
          >
            <div className="flex ver full--col">
              {childs.map((val, i) => (
                <div
                  className={`com-shop-preview__pic-list__item ${
                    i === onIndex ? "active" : ""
                  }`}
                  onClick={
                    onChange && typeof onChange === "function"
                      ? onChange.later(i)
                      : this.onChange.later(i)
                  }
                >
                  <img className="lazyload" data-src={val.pic} />
                </div>
              ))}
            </div>
          </Scrollbars>
        </section>
      </div>
    );
  }
}
export default View;
